import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLineThickness: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="line-thickness, lines, border"><path d="M4 5.75L20 5.75" stroke="currentColor" strokeWidth="1.25"/><path d="M4 17.25L20 17.25" stroke="currentColor" strokeWidth="3.25"/><path d="M4 11L20 11" stroke="currentColor" strokeWidth="2.25"/></CentralIconBase>;
};

export default IconLineThickness;
